import React from 'react';

import Header from '../../components/Header';
import Title from '../../components/Title';
import Text from '../../components/Text';
import Line from '../../components/Line';
import List from '../../components/List';
import Card from './Card';
import Actions from '../../components/Actions';
import MobileMenuHeader from '../../components/MobileMenuHeader';

export default function Intro(props) {
  const {
    nextClickHandler,
    menuItems,
    selectComponent,
    componentIndex,
    rules,
    backPath,
    locales,
    locales: {
      common,
      tipCustomerSegment,
      keyActivity: {
        name,
        intro: { header, title, text, list, card },
      },
    },
  } = props;

  return (
    <section className="bmc-page" aria-label={header}>
      <Header
        title={header}
        subtitle={name}
        icon="icon-key-activity"
        locales={locales}
        componentIndex={componentIndex}
        className="bmc-page-header--orange"
        tipLocales={tipCustomerSegment}
        menuItems={menuItems}
        onMenuItemClick={selectComponent}
        rules={rules}
        backPath={backPath}
        mobileMenuHeader={
          <MobileMenuHeader icon="KeyThingCanvas" title={name} color="orange" />
        }
      />

      <Text>{[text[0], text[1]]}</Text>

      <Title text={title[0]} align="left" />

      <List items={list} />

      <Line />

      <Title text={title[1]} className="margin-top-60" />

      <Text align="center">{[text[2]]}</Text>

      <Card
        card={card}
        className="margin-top-60 margin-wide-40-lg bmc-page-keycard--section"
      />

      <Actions nextClickHandler={nextClickHandler} buttonName={common.next} />
    </section>
  );
}
